import request from '@/utils/request';

// 文件上传
export function fileUpload(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/file/upload',
			method: 'post',
			data,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '文件上传失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 获取文件列表
export function fileDownloadList() {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/file/list',
			method: 'get',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取文件列表失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 文件下载
export function fileDownload(filename) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/file/download/${filename}`,
			method: 'get',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '文件下载失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 删除文件
export function fileDelete(filename) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/file/delete/${filename}`,
			method: 'delete',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '删除文件失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}
